import { Entrepreneur } from '../Model/Entrepreneur';
import { storeApi } from './storeApi';

export const entrepreneurApi = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    authorizeEntrepreneur: builder.query<any, { email: string; recaptcha: string }>({
      query: (arg) => {
        const { email, recaptcha } = arg;
        return {
          url: '/entr/auth',
          method: 'POST',
          body: { email, captcha_response: recaptcha },
        };
      },
    }),
    updateEntrepreneur: builder.mutation<Entrepreneur, Partial<Entrepreneur>>({
      query(data) {
        const { ...body } = data;
        return {
          url: '/entr',
          method: 'PUT',
          body,
        };
      },
    }),
  }),
});

export const { useLazyAuthorizeEntrepreneurQuery, useUpdateEntrepreneurMutation } = entrepreneurApi;
